"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_router_dom_1 = require("react-router-dom");
const TitleBarStyle_1 = require("./styles/TitleBarStyle");
// @ts-ignore
const LogoPerfecto_png_1 = require("../images/LogoPerfecto.png");
function TitleBar(props) {
    const history = react_router_dom_1.useHistory();
    const { title, showBack, showHome } = props;
    const goBack = () => {
        if (showHome) {
            history.push('/');
        }
        else if (showBack) {
            history.goBack();
        }
    };
    function renderNavLogo() {
        if (showHome) {
            return React.createElement(TitleBarStyle_1.Logo, { src: LogoPerfecto_png_1.default, alt: "logo" });
        }
        if (showBack) {
            return React.createElement(TitleBarStyle_1.BackButton, null);
        }
    }
    function renderNav() {
        if (showHome || showBack) {
            return (React.createElement(TitleBarStyle_1.Icon, { edge: "start", color: "inherit", "aria-label": "menu", onClick: goBack }, renderNavLogo()));
        }
    }
    return (React.createElement("div", null,
        React.createElement(TitleBarStyle_1.Title, { position: "static" },
            React.createElement(TitleBarStyle_1.ToolBarEntio, null,
                renderNav(),
                React.createElement(TitleBarStyle_1.TypographyEntio, { variant: "h6" }, title || '')))));
}
exports.default = TitleBar;
//# sourceMappingURL=TitleBar.js.map